// Shared constants — mirrors backend models.PROPERTY_TYPES

export const PROPERTY_TYPES = [
  { value: 'residential',       label: 'Residential' },
  { value: 'studio_apartment',  label: 'Studio Apartment' },
  { value: 'building',          label: 'Building' },
  { value: 'farm_house',        label: 'Farm House' },
  { value: 'commercial_office', label: 'Commercial Office' },
  { value: 'land',              label: 'Land' },
  { value: 'warehouse',         label: 'Warehouse' },
  { value: 'shop',              label: 'Shop' },
  { value: 'showroom',          label: 'Showroom' },
];

export const PROPERTY_TYPE_LABEL = Object.fromEntries(PROPERTY_TYPES.map((t) => [t.value, t.label]));

export const ROLE_LABEL = {
  admin: 'Super Admin',
  owner: 'Property Owner',
  consultant: 'Consultant',
  agent: 'Agent',
  tenant: 'Tenant',
};

export const KYC_STATUS_LABEL = {
  pending:   'Pending',
  submitted: 'Submitted',
  approved:  'Approved',
  rejected:  'Rejected',
};

export const KYC_STATUS_COLOR = {
  pending:   'bg-slate-100 text-slate-700 border-slate-200',
  submitted: 'bg-amber-50 text-amber-700 border-amber-200',
  approved:  'bg-emerald-50 text-emerald-700 border-emerald-200',
  rejected:  'bg-rose-50 text-rose-700 border-rose-200',
};

export const FURNISHING_OPTIONS = [
  { value: 'unfurnished', label: 'Unfurnished' },
  { value: 'semi',        label: 'Semi-furnished' },
  { value: 'fully',       label: 'Fully furnished' },
];

export const NOTE_TYPES = [
  { value: 'visit',      label: 'Visit Note' },
  { value: 'lead',       label: 'Lead Note' },
  { value: 'status',     label: 'Status Update' },
  { value: 'followup',   label: 'Follow-up' },
  { value: 'inspection', label: 'Inspection Note' },
  { value: 'general',    label: 'General' },
];

export const LEAD_STATUSES = [
  { value: 'new',                label: 'New' },
  { value: 'contacted',          label: 'Contacted' },
  { value: 'viewing_scheduled',  label: 'Viewing Scheduled' },
  { value: 'offer',              label: 'Offer Made' },
  { value: 'closed_won',         label: 'Closed - Won' },
  { value: 'closed_lost',        label: 'Closed - Lost' },
];
